import { FileTextIcon, DownloadIcon, ActivityIcon, SmartphoneIcon } from 'lucide-react';

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/8jjZRcwVVPuTTtLiJUhtmP/Kit_digital_Sigma_Smart_para_triatlon.webp';

export const heroChips = [
  { icon: FileTextIcon, label: '100% Visual PDF' },
  { icon: DownloadIcon, label: 'Instant Download' },
  { icon: ActivityIcon, label: 'All Training Levels' },
  { icon: SmartphoneIcon, label: 'Android & iOS' },
];

export const disciplines = ['Swim', 'Bike', 'Run', 'Fuel', 'Progress', 'Race Execution'];
